/**
 * Normalizadores wire → *Local para `/tenants/{tenantId}/levels/{level}/entities/*`.
 *
 * El wire shape coincide con el contrato generado (`backoffice.gen.ts`); la única transformación
 * es epoch ms (number) → ISO string en `createdAt`, para que la UI renderice la fecha con
 * `formatDateMx` sin tocar `Date` en el componente. Siempre con defaults (nunca dejan un campo
 * requerido en `undefined`), igual que `platformNormalizers.ts`. Se aplican dentro de
 * `levelEntityApi.*`.
 */
import type { LevelEntityWire, LevelEntityListItemLocal } from './LevelEntityLocal';

/** epoch ms (number) | nulo → ISO string (o '' si no hay dato). */
function toIso(value: number | null | undefined): string {
    if (value === undefined || value === null) return '';
    return new Date(value).toISOString();
}

export function normalizeLevelEntity(wire: LevelEntityWire): LevelEntityListItemLocal {
    return {
        id: wire.id,
        displayName: wire.displayName,
        parentId: wire.parentId,
        level: wire.level,
        createdAt: toIso(wire.createdAt),
    };
}

export function normalizeLevelEntityList(wire: { items?: LevelEntityWire[] }): {
    items: LevelEntityListItemLocal[];
} {
    return { items: (wire.items ?? []).map(normalizeLevelEntity) };
}
